define('models/Notification',[
	'jquery',
	'core/can',
	'models/Base',
	'models/Claim',
	'signalr.hubs'
], function($, can, Base, Claim, $connection) {

	var hub = $connection.notificationHub.server;
	
	function makeFindAll(method) {
		return function() {
			var self = this;
			return hub[method]().then(function(data) {
				return self.models(data);
			});
		}
	}
	
	var Notification = Base.extend({
		
		id: 'NotificationId',
		types: [],
		
		getAll: makeFindAll('getAll'),
		
		getDismissed: makeFindAll('getDismissed'),
		
		getRead: makeFindAll('getRead'),
		
		getUnread: makeFindAll('getUnread'),
		
		getUserId: makeFindAll('getUserId'),
		
		models: function(n) {
			var list = new this.List;
			for (var i=0; i<n.length; i++) {
				list.push(this.model(n[i]));
			}
			return list;
		},
		
		model: function(n) {
			for (var i=0; i<this.types.length; i++) {
				var type = n.Type.split(".").pop();
				if (type === this.types[i].type) {
					return new this.types[i](n);
				}
			}
			return new this(n);
		}
	
	},{
		
		_Type: can.compute(function() {
			return this.attr('Type').split('.').pop();
		}),
		
		_isUnread: can.compute(function() {
			return this.attr('State') === 0;
		}),
		
		_isRead: can.compute(function() {
			return this.attr('State') === 1;
		}),
		
		_isDismissed: can.compute(function() {
			return this.attr('State') === 2;
		}),		
		
		markUnread: function() {
			this.attr('State', 0);
			hub.markUnread(this.attr());
			return this;
		},
		
		markRead: function() {
			this.attr('State', 1);
			hub.markRead(this.attr());
			return this;
		},
		
		markDismissed: function() {
			this.attr('State', 2);
			hub.markRead(this.attr());
			return this;
		}
		
	});
	
	Notification.List = Notification.List.extend({
		
		_numUnread: can.compute(function() {
			var length = this.attr('length'),
				numUnread = 0;
			for (var i=0; i<length; i++) {
				if (this.attr(i).attr('State') === 0) {
					++numUnread;
				}
			}
			return numUnread;
		})
		
	});
	
	Notification.types.push(Notification.extend({
		type: 'DdeCheckNotification'
	},{
		
		// DdeUsername
		// DdeCheckStatus
			// AuthenticatedAndAuthorized
			// Authenticated
			// NotAuthenticated
		_DdeCheckStatus: can.compute(function() {
			switch(this.attr('DdeCheckStatus')) {
				case 0: return 'Authorized';
				case 1: return 'Authenticated';
				case 2: return 'Not Authenticated';
			}
		})
		
	}));
	
	Notification.types.push(Notification.extend({
		type: 'ClaimSubmissionNotification'
	},{
		
		// ClaimId
		// ReceivedDate
		
		// TypeOfBill
		_TypeOfBill: Claim.prototype._TypeOfBill,

		// TypeOfClaim
		// _TypeOfClaim: Claim.prototype._TypeOfClaim,
		
		// Status
		_Status: Claim.prototype._Status,
		
		// StatusCode
		// LocationCode
		_MedicareStatus: Claim.prototype._MedicareStatus,

		_IsRejected: can.compute(function() {
			return (this.attr('_TypeOfBill') === 'Rejected');
		}),

		_isErrored: Claim.prototype._isErrored,

		_isSuppressed: can.compute(function() {
			return (this.attr('CommandType') === 14);
		}),
		
		// PatientFirstName
		// PatientLastName
		_PatientName: can.compute(function() {
			var f = this.attr('PatientFirstName'),
				l = this.attr('PatientLastName');
			return (f&&l)?l+', '+f:f||l;
		}),

		_isCancellation: can.compute(function() {
			return this.attr('CommandType') === 6;
		})
	}));
	
	Notification.types.push(Notification.extend({
		type: 'EligibilityNotification'
	},{
		
		// EligibilityId
		// Status
			// 0 Created
			// 1 Processing
			// 2 Pending
			// 3 Success
			// 5 Errored
			// 7 Unknown
		
		_isPending: can.compute(function() {
            return this.attr('EligibilityStatus') === 0 || this.attr('EligibilityStatus') === 1 || this.attr('EligibilityStatus') === 2;
		}),
		
		_isReady: can.compute(function() {
			return this.attr('EligibilityStatus') === 3;
		}),
		
		_isErrored: can.compute(function() {
			return this.attr('EligibilityStatus') === 5 || this.attr('EligibilityStatus') === 7;
		}),
		
		// PatientFirstName
		// PatientLastName
		_PatientName: can.compute(function() {
			var f = this.attr('PatientFirstName'),
				l = this.attr('PatientLastName');
			return (f&&l)?l+', '+f:f||l;
		})
	}));

	return Notification;

});
